<template>
  <div class="card-filter">
    <el-row
      type="flex"
      align="start"
      justify="space-between"
      class="flex-wrap mb-l gap-12"
    >
      <el-row
type="flex"
align="middle">
        <el-input
          v-model="textSearch"
          class="text-search mr-m"
          size="medium"
          placeholder="Nhập thông tin để tìm kiếm"
          clearable
        />
        <el-button
          size="medium"
          type="primary"
          plain
          icon="el-icon-search"
          @click="searchNormal"
        >
          Tìm kiếm
        </el-button>
      </el-row>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "CardFilter",
  props: {},
  data() {
    return {
      textSearch: "",
    };
  },
  computed: {},
  methods: {
    searchNormal() {
      this.$emit("search", {
        searchText: this.textSearch,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.card-filter {
  .text-search {
    min-width: 200px;
  }
}
</style>
